var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-block"},[_vm._m(0),_c('div',{staticClass:"add-img__block"},[_c('ImgBlock',{attrs:{"data-img-list":_vm.dataImgList,"data-img":_vm.dataImg,"disabled-show":_vm.editDisabled}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-block__head"},[_c('h1',{staticClass:"main-block__title"},[_vm._v("Фото документов *")])])
}]

export { render, staticRenderFns }